import React from "react";
import { pathUrl } from "./path-url";

// Public
const login = React.lazy(() => import("../containers/login"));
const changePassword = React.lazy(() => import("../containers/service-sso/change-password"));
// private
const home = React.lazy(() => import("../containers/home"));
const page500 = React.lazy(() => import("../containers/page-500"));
const page400 = React.lazy(() => import("../containers/page-400"));
const user = React.lazy(() => import("../containers/service-sso/user"));
const userDetail = React.lazy(() => import("../containers/service-sso/user/detail"));
const role = React.lazy(() => import("../containers/service-sso/role"));
const roleDetail = React.lazy(() => import("../containers/service-sso/role/detail"));
const permission = React.lazy(() => import("../containers/service-sso/permission"));
const permissionDetail = React.lazy(() => import("../containers/service-sso/permission/detail"));
const rolePermission = React.lazy(() => import("../containers/service-sso/role-permission"));
const merchant = React.lazy(() => import("../containers/service-booking/merchant"));
const merchantDetail = React.lazy(() => import("../containers/service-booking/merchant/detail"));
const store = React.lazy(() => import("../containers/service-booking/store"));
const storeDetail = React.lazy(() => import("../containers/service-booking/store/detail"));
const service = React.lazy(() => import("../containers/service-booking/service"));
const serviceDetail = React.lazy(() => import("../containers/service-booking/service/detail"));
const schedule = React.lazy(() => import("../containers/service-schedule/schedule"));
const scheduleDetail = React.lazy(() => import("../containers/service-schedule/schedule/detail"));
const bookingObject = React.lazy(() => import("../containers/service-booking/booking-object"));
const bookingObjectDetail = React.lazy(() => import("../containers/service-booking/booking-object/detail"));
const device = React.lazy(() => import("../containers/service-device/device"));
const deviceDetail = React.lazy(() => import("../containers/service-device/device/detail"));
const config = React.lazy(() => import("../containers/service-setting/config"));
const configDetail = React.lazy(() => import("../containers/service-setting/config/detail"));
const trackingRequest = React.lazy(() => import("../containers/service-tracking/tracking-request"));
const trackingRequestDetail = React.lazy(() => import("../containers/service-tracking/tracking-request/detail"));
const notification = React.lazy(() => import("../containers/service-setting/notification"));
const notificationDetail = React.lazy(() => import("../containers/service-setting/notification/detail"));
const cmsPage = React.lazy(() => import("../containers/service-cms/cms-page"));
const cmsPageDetail = React.lazy(() => import("../containers/service-cms/cms-page/detail"));
const cmsBlock = React.lazy(() => import("../containers/service-cms/cms-block"));
const cmsBlockDetail = React.lazy(() => import("../containers/service-cms/cms-block/detail"));
const cmsMenu = React.lazy(() => import("../containers/service-cms/cms-menu"));
const cmsMenuDetail = React.lazy(() => import("../containers/service-cms/cms-menu/detail"));
const cmsBlog = React.lazy(() => import("../containers/service-cms/cms-blog"));
const cmsBlogDetail = React.lazy(() => import("../containers/service-cms/cms-blog/detail"));
const manageUploadFile = React.lazy(() => import("../containers/service-media/manage-upload-file"));
const manageUploadFileDetail = React.lazy(() => import("../containers/service-media/manage-upload-file/detail"));

export interface IRouter {
  path: string;
  title: string;
  component: any;
}

export const pageRouter: IRouter[] = [
  {
    path: pathUrl.HOME,
    title: "home",
    component: home,
  },
  {
    path: pathUrl.PAGE_500,
    title: "Page 500",
    component: page500,
  },
  {
    path: pathUrl.PAGE_400,
    title: "Page 400",
    component: page400,
  },
  {
    path: pathUrl.LOGIN,
    title: "login",
    component: login,
  },
  {
    path: pathUrl.CHANGE_PASSWORD,
    title: "Change password",
    component: changePassword,
  },
  {
    path: pathUrl.USER.INDEX,
    title: "User",
    component: user,
  },
  {
    path: pathUrl.USER.DETAIL,
    title: "User detail",
    component: userDetail,
  },
  {
    path: pathUrl.ROLE.INDEX,
    title: "Role",
    component: role,
  },
  {
    path: pathUrl.ROLE.DETAIL,
    title: "Role detail",
    component: roleDetail,
  },
  {
    path: pathUrl.PERMISSION.INDEX,
    title: "Permission",
    component: permission,
  },
  {
    path: pathUrl.PERMISSION.DETAIL,
    title: "Permission detail",
    component: permissionDetail,
  },
  {
    path: pathUrl.ROLE_PERMISSION.INDEX,
    title: "role permission",
    component: rolePermission,
  },
  {
    path: pathUrl.MERCHANT.INDEX,
    title: "merchant",
    component: merchant,
  },
  {
    path: pathUrl.MERCHANT.DETAIL,
    title: "Merchant detail",
    component: merchantDetail,
  },
  {
    path: pathUrl.STORE.INDEX,
    title: "store",
    component: store,
  },
  {
    path: pathUrl.STORE.DETAIL,
    title: "Store detail",
    component: storeDetail,
  },
  {
    path: pathUrl.SERVICE.INDEX,
    title: "service",
    component: service,
  },
  {
    path: pathUrl.SERVICE.DETAIL,
    title: "Service detail",
    component: serviceDetail,
  },
  {
    path: pathUrl.SCHEDULE.INDEX,
    title: "schedule",
    component: schedule,
  },

  {
    path: pathUrl.SCHEDULE.DETAIL,
    title: "schedule detail",
    component: scheduleDetail,
  },
  {
    path: pathUrl.BOOKING_OBJECT.INDEX,
    title: "booking object",
    component: bookingObject,
  },
  {
    path: pathUrl.BOOKING_OBJECT.DETAIL,
    title: "booking object detail",
    component: bookingObjectDetail,
  },
  {
    path: pathUrl.DEVICE.INDEX,
    title: "Device",
    component: device,
  },
  {
    path: pathUrl.DEVICE.DETAIL,
    title: "Device detail",
    component: deviceDetail,
  },
  {
    path: pathUrl.CONFIG.INDEX,
    title: "config",
    component: config,
  },
  {
    path: pathUrl.CONFIG.DETAIL,
    title: "config detail",
    component: configDetail,
  },
  {
    path: pathUrl.TRACKING_REQUEST.INDEX,
    title: "tracking request",
    component: trackingRequest,
  },
  {
    path: pathUrl.TRACKING_REQUEST.DETAIL,
    title: "tracking request detail",
    component: trackingRequestDetail,
  },

  {
    path: pathUrl.NOTIFICATION.INDEX,
    title: "notification",
    component: notification,
  },

  {
    path: pathUrl.NOTIFICATION.DETAIL,
    title: "notification detail",
    component: notificationDetail,
  },

  {
    path: pathUrl.CMS_PAGE.INDEX,
    title: "cms page",
    component: cmsPage,
  },

  {
    path: pathUrl.CMS_PAGE.DETAIL,
    title: "cms page detail",
    component: cmsPageDetail,
  },

  {
    path: pathUrl.CMS_BLOCK.INDEX,
    title: "cms block",
    component: cmsBlock,
  },

  {
    path: pathUrl.CMS_BLOCK.DETAIL,
    title: "cms block detail",
    component: cmsBlockDetail,
  },

  {
    path: pathUrl.CMS_MENU.INDEX,
    title: "cms menu",
    component: cmsMenu,
  },

  {
    path: pathUrl.CMS_MENU.DETAIL,
    title: "cms menu detail",
    component: cmsMenuDetail,
  },

  {
    path: pathUrl.CMS_BLOG.INDEX,
    title: "cms blog",
    component: cmsBlog,
  },

  {
    path: pathUrl.CMS_BLOG.DETAIL,
    title: "cms blog detail",
    component: cmsBlogDetail,
  },

  {
    path: pathUrl.MANAGE_UPLOAD_FILE.INDEX,
    title: "manage upload file",
    component: manageUploadFile,
  },

  {
    path: pathUrl.MANAGE_UPLOAD_FILE.DETAIL,
    title: "manage upload file detail",
    component: manageUploadFileDetail,
  },
];
